import React from "react"
import dateService from "services/date"
import { sessionStorageService, TIMER_KEY } from "services/browserStorage"

const Timer = ({
    className = "",
    style = {},
    timeToWait,
    saveTimerInStorage = false
}) => {
    // timeToWait should be in milliseconds

    const savedDate = React.useMemo(() => sessionStorageService.get(TIMER_KEY), [])
    if (saveTimerInStorage) {
        if (!savedDate || !dateService.isValidDate(new Date(savedDate))) {
            sessionStorageService.set(TIMER_KEY, new Date())
        }
    }

    const startingDate = saveTimerInStorage
        ? new Date(sessionStorageService.get(TIMER_KEY))
        : new Date()

    const startingDateRef = React.useRef(startingDate)
    const timerRef = React.useRef()

    const calculateTimeLeft = () => timeToWait - (new Date() - startingDateRef.current)

    const [showTimer, setShowTimer] = React.useState(!!timeToWait)
    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft())
    const [timerClassNameColor, setTimerClassNameColor] = React.useState("text-successColor")

    const onTimerEnd = () => {
        sessionStorageService.remove(TIMER_KEY)
        clearTimeout(timerRef.current)
        setShowTimer(false)
    }

    React.useEffect(() => {
        timerRef.current = setTimeout(() => {
            setTimeLeft(calculateTimeLeft())
        }, 1000)
        // Clear timeout if the component is unmounted
        return () => clearTimeout(timerRef.current)
    })

    React.useEffect(() => {
        if (timeLeft <= (50 * timeToWait / 100)) setTimerClassNameColor("u-warning")
        if (timeLeft <= (20 * timeToWait / 100)) setTimerClassNameColor("text-danger u-blink")
        if (timeLeft <= 0) onTimerEnd()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLeft])

    return (
        <>
            {showTimer && (
                <span className={`${className} font-bold ${timerClassNameColor}`} style={style}>
                    {dateService.getMinutesAndSecondsString(timeLeft)}
                </span>
            )}
            {!showTimer && (
                <span className={`${className} font-bold text-danger u-blink`} style={style}>
                   00:00
                </span>
            )}
        </>

    )
}

export default Timer